import React, { memo, useCallback, useContext, useEffect, useMemo, useState } from "react"
import Money from "../../../../../helpers/utils/money/money"
import TableCustom from "../../../../../components/MyCustom/TableCustom"
import ModalCmvList from "../../../../../components/modals/Cmv/ModalCmvList";
import { DefaultContext } from "../../../../../contexts/default";
import Button from "../../../../../components/bootstrap/Button";
import useDarkMode from "../../../../../hooks/useDarkMode";
import ModalRegisterInsumo from "../../../../../components/modals/Cmv/ModalRegisterInsumo";
import InsumosDB from "../../../../../database/wrappers/insumos";
import useCmvProducts from "../../../../../hooks/reports/useCmvProducts";
import TableCustomCmv from "../../../../../components/MyCustom/TableCustomCmv";
import useCmvHistory from "../../../../../hooks/reports/useCmvHistory";
import { convertGramaToKg, convertGramaToKg2, getFloatCMV, getMediumPriceCMV } from "../../../../../utils/cmv/convertQtd";
import Spinner from "../../../../../components/bootstrap/Spinner";

const TabCMVInsumo = ({ hidden, dataFilter }) => {
    const { darkModeStatus } = useDarkMode()
    const { reports, loading } = useCmvHistory(dataFilter)

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, '0');
        return [
            {
                label: `${day} - Qtd`,
                field: `{row}`,
                formatExport: (row) => row?.days[day]?.qtd ?? 0,
                hidden: true,
            },
            {
                label: `Total`,
                field: `{row}`,
                formatExport: (row) => {
                    const total = row?.days[day]?.qtd ?? 0;
                    const qtd = row?.days[day]?.price ?? 0
                    const totalPago = qtd > 0 ? total * qtd : 0;
                    return Money.centsToCoinCsv(totalPago)
                },
                hidden: true,
            }
        ];
    }).flat();

    const columns = useMemo(() => [
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'Unidade',
            field: 'unit',
        },
        ...days,
        {
            label: 'Saída Automática Total',
            field: '{row}',
            format: row => getFloatCMV(row.qtdExitAutomatic),
            formatExport: row => getFloatCMV(row.qtdExitAutomatic),
        },
        {
            label: 'Saída Manual Total',
            field: '{row}',
            format: (row) => {
                const manual = row.qtdExit ?? 0;
                const automatic = row.qtdExitAutomatic ?? 0;
                const value = getFloatCMV(manual);
                const upperLimit = automatic * 1.05;
                const lowerLimit = automatic * 0.95;

                const style = (() => {
                    if (manual >= upperLimit) {
                        return { color: 'red', fontWeight: 'bold' };
                    }
                    if (manual <= lowerLimit) {
                        return { color: '#DAA520', fontWeight: 'bold' };
                    }
                    return { color: 'inherit', fontWeight: 'normal' };
                })();

                return <span style={style}>{value}</span>;
            },
            formatExport: (row) => getFloatCMV(row.qtdExit),
        },
        {
            label: 'Saída Perda Total',
            field: '{row}',
            format: row => getFloatCMV(row.qtdLoss),
            formatExport: row => getFloatCMV(row.qtdLoss),
        },
        {
            label: 'Saída Cortesia Total',
            field: '{row}',
            format: row => getFloatCMV(row.qtdPromotial),
            formatExport: row => getFloatCMV(row.qtdPromotial),
        },
        {
            label: 'Saída Real Total',
            field: '{row}',
            format: row => {
                const saidaReal = (row.qtdExit ?? 0) + (row.qtdLoss ?? 0) + (row.qtdPromotial ?? 0);
                return getFloatCMV(saidaReal);
            },
            formatExport: row => {
                const saidaReal = (row.qtdExit ?? 0) + (row.qtdLoss ?? 0) + (row.qtdPromotial ?? 0);
                return getFloatCMV(saidaReal);
            }
        },
    ], [darkModeStatus, days])

    return (
        <div hidden={hidden}>
            {loading ? (
                <div className="d-flex flex-column justify-content-center align-items-center h-100">
                    <Spinner
                        className='text-center'
                        color='blue'
                        size={72}
                        tag='span'
                    />                      </div>
            ) : (
                <TableCustomCmv
                    titlePdf='cmv-insumo'
                    icon='TableChart'
                    fontSize={8}
                    rows={reports}
                    columns={columns}
                    fileName='CMV-Insumo'
                    type="cmvInsumo"
                />
            )}
        </div>
    )
}

export default memo(TabCMVInsumo)